import { Text, View } from "react-native";
import { getFullName } from "ui/utils/nameUtil";
import { format } from "date-fns";
import { SubmittedFormModel } from "../../../services/api/types/forms/models/SubmittedFormModel";

interface Props {
  submittedForm: SubmittedFormModel;
}

export function AssessmentNotes({ submittedForm }: Props) {
  return (
    <View>
      {submittedForm.post_submission_notes.length > 0 && (
        <View>
          <View className="border-b border-gray-200 my-4" />
          <View className="gap-4">
            <Text className="text-md font-semibold">Notes</Text>
            {submittedForm.post_submission_notes.map((note) => (
              <View key={note.id} className="gap-2">
                <View className="grid grid-cols-1 sm:grid-cols-3 mb-4">
                  <View className="flex flex-col">
                    <Text className="text-gray-600 mb-2">Actioned by</Text>
                    <Text>{getFullName(note.user)} on</Text>
                    <Text>
                      {format(
                        new Date(note.created_at),
                        "dd-MM-yyyy 'at' HH:mm",
                      )}
                    </Text>
                  </View>

                  <View className="flex flex-col">
                    <Text className="text-gray-600 mb-2">Note</Text>
                    <Text className="text-md">{note.note}</Text>
                  </View>
                </View>
              </View>
            ))}
          </View>
        </View>
      )}
    </View>
  );
}
